import React from "react";
import { useMutation } from "react-query";
// import { secureAxios, secureBotAxios } from "../_helpers/auth";
import { queryClient } from "../_helpers/query";
import { botSecureAxios } from "./bot";

export const useTestq0 = (onSuccess = () => {}, onDone = () => {}) => {
    return useMutation(
        (newItem) => {
            return botSecureAxios
                .post(`/q0/generate`, newItem)
                .then((res) => res.data);
        },
        {
            onSuccess: (data, variables, context) => {
                onSuccess(data);
                onDone();
            },
        }
    );
};

export const useTestq0Image = (onSuccess = () => {}, onDone = () => {}) => {
    return useMutation(
        (newItem) => {
            return botSecureAxios
                .post(`/q0/design_from_image`, newItem)
                .then((res) => res.data);
        },
        {
            onSuccess: (data, variables, context) => {
                onSuccess(data);
                onDone();
            },
        }
    );
};
